export default __webpack_public_path__ + "static/media/VD3.4b1c943b.png";